// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { ExternalNetworkWithRelationsSchema } from './ExternalNetworkRelationsSchema'
import type { ExternalNetworkWithRelations } from './ExternalNetworkRelationsSchema'
import { ExternalNetworkWebAppCandidateWithRelationsSchema } from './ExternalNetworkWebAppCandidateRelationsSchema'
import type { ExternalNetworkWebAppCandidateWithRelations } from './ExternalNetworkWebAppCandidateRelationsSchema'
import { ExternalNetworkWebAppClusterSchema } from './ExternalNetworkWebAppClusterSchema';

/////////////////////////////////////////
// EXTERNAL NETWORK WEB APP CLUSTER RELATION SCHEMA
/////////////////////////////////////////

export type ExternalNetworkWebAppClusterRelations = {
  surface: ExternalNetworkWithRelations;
  members: ExternalNetworkWebAppCandidateWithRelations[];
};

export type ExternalNetworkWebAppClusterWithRelations = z.infer<typeof ExternalNetworkWebAppClusterSchema> & ExternalNetworkWebAppClusterRelations

export const ExternalNetworkWebAppClusterWithRelationsSchema: z.ZodType<ExternalNetworkWebAppClusterWithRelations> = ExternalNetworkWebAppClusterSchema.merge(z.object({
  surface: z.lazy(() => ExternalNetworkWithRelationsSchema),
  members: z.lazy(() => ExternalNetworkWebAppCandidateWithRelationsSchema).array(),
}))